import { render, staticRenderFns } from "./InvitationFirend.vue?vue&type=template&id=6e8cd016&scoped=true&"
import script from "./InvitationFirend.vue?vue&type=script&lang=js&"
export * from "./InvitationFirend.vue?vue&type=script&lang=js&"
import style0 from "./InvitationFirend.vue?vue&type=style&index=0&id=6e8cd016&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8cd016",
  null
  
)

export default component.exports